module.exports = __webpack_public_path__ + "static/favicon/android-chrome-192x192.png";